/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_How_1_TagInputs */

const en_mk_how_1_tag = /** @type {(inputs: Mk_How_1_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Step 1`)
};

const id_mk_how_1_tag = /** @type {(inputs: Mk_How_1_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langkah 1`)
};

/**
* | output |
* | --- |
* | "Step 1" |
*
* @param {Mk_How_1_TagInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_how_1_tag = /** @type {((inputs?: Mk_How_1_TagInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_How_1_TagInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_how_1_tag(inputs)
	return en_mk_how_1_tag(inputs)
});